export default __webpack_public_path__ + "static/media/Gellix-ExtraBoldItalic.f5ec4604.woff";